import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { getSocietySelected } from "@icarius-pages/login/selectors";
import NineBoxIndicator from "@icarius-common/nineBoxIndicator";
import Likes from "@icarius-common/likes";
import QR from "@icarius-common/qr";
import ProfileImg from "@icarius-common/profileImg";
import { getEmployeeOpinion } from "../../selectors";
import { CustomButton } from "@icarius-pages/myPersonalData/components/userSummary";

const UserSummary = (props) => {
    const {
        isNewEmployee,
        isPhotoModificable,
        isSameUser,
        photo,
        employee,
        handleOpenCertificate,
        handleOpenReceipt,
        handleLikeRequest,
        handleOpenQueries,
        handleOpenChangePhotoDialog,
        handleDownloadPositionDescription,
    } = props;

    const color = useSelector(getAppColor);
    const societySelected = useSelector(getSocietySelected);
    const employeeOpinion = useSelector(getEmployeeOpinion);

    const qr =
        employee &&
        "BEGIN:VCARD\n" +
            "VERSION:3.0\n" +
            "N:" +
            employee["APELLIDO Y NOMBRE"] +
            "\n" +
            "ORG:" +
            societySelected.name +
            "\n" +
            "TITLE:" +
            employee["CARGO"] +
            "\n" +
            "TEL:" +
            employee["CELULAR"] +
            "\n" +
            "EMAIL:" +
            employee["EMAIL"] +
            "\n" +
            "END:VCARD\n";

    return (
        <Grid container item xs={12} alignItems="center" spacing={2}>
            <Grid container alignItems="center" justify="center" item sm={12} md={2}>
                <div className={"photo-container"}>
                    <ProfileImg
                        image={photo}
                        size={100}
                        editable={isPhotoModificable}
                        handleChange={handleOpenChangePhotoDialog}
                    />
                </div>
            </Grid>
            {!isNewEmployee && (
                <Grid container direction="column" item sm={12} md={8}>
                    <Typography
                        style={{
                            fontWeight: 200,
                            fontSize: "20px",
                            lineHeight: "28px",
                        }}
                        className={"whiteText"}
                        variant="subtitle1"
                    >
                        {employee["APELLIDO Y NOMBRE"]}
                    </Typography>
                    {employee?.["MANAGER"] && employee?.["MANAGER"] !== "-" && (
                        <Typography
                            style={{
                                color: color,
                                fontWeight: 400,
                                fontSize: "20px",
                                lineHeight: "28px",
                            }}
                        >
                            {getLocalizedString("managerColon") + employee["MANAGER"]}
                        </Typography>
                    )}
                    {employee["ESTADO"] && (
                        <Typography
                            className={"whiteText"}
                            style={{
                                fontWeight: 200,
                                fontSize: "20px",
                                lineHeight: "28px",
                            }}
                        >
                            {employee["ESTADO"] === "Vigente"
                                ? getLocalizedString("vigente")
                                : getLocalizedString("noVigente")}
                        </Typography>
                    )}
                    {Boolean(employee["nine_box"]) && (
                        <div style={{ paddingTop: 10 }}>
                            <NineBoxIndicator data={employee["nine_box"]} />
                        </div>
                    )}
                    <div style={{ paddingTop: 10 }}>
                        <Likes
                            active={employee["ESTADO"] === "Vigente"}
                            value={employeeOpinion}
                            handleLike={(like, oldValue) =>
                                handleLikeRequest(employee["CODIGO DE EMPLEADO"], like, oldValue)
                            }
                        />
                    </div>
                </Grid>
            )}
            {!isNewEmployee && (
                <Grid container item sm={12} md={2} justify="center" alignItems="center">
                    <QR value={qr} hideLabel />
                </Grid>
            )}
            {!isNewEmployee && (
                <div style={{ width: "100%", display: "flex", gap: 10, flexWrap: "wrap" }}>
                    {[
                        {
                            label: getLocalizedString("certificates"),
                            onClick: handleOpenCertificate,
                            enabled: !isSameUser,
                        },
                        {
                            label: getLocalizedString("receipts"),
                            onClick: handleOpenReceipt,
                            enabled: !isSameUser,
                        },
                        {
                            label: getLocalizedString("query"),
                            onClick: handleOpenQueries,
                            enabled: true,
                        },
                        {
                            label: getLocalizedString("positionDescription"),
                            onClick: handleDownloadPositionDescription,
                            enabled: employee?.hasPositionDescription,
                        },
                    ].map((item, index) => {
                        if (!item.enabled) return null;
                        return (
                            <div key={index} style={{ flex: 1, minWidth: 220 }}>
                                <CustomButton onClick={item.onClick} variant={"contained"}>
                                    {item.label}
                                </CustomButton>
                            </div>
                        );
                    })}
                </div>
            )}
        </Grid>
    );
};

export default UserSummary;
